import { jsS } from "@pnp/common";
export function body(o, previous) {
    return Object.assign({ body: jsS(o) }, previous);
}
// eslint-disable-next-line @typescript-eslint/ban-types
export function headers(o, previous) {
    return Object.assign({ headers: o }, previous);
}
